<template>
  <div class="container">
    <div class="show_data_box" style="margin-top: 10px;">
      <div class="header">
        <div class="title">热门评论词</div>
        <div class="tip">点击热词可切换评论内容</div>
      </div>
      <img v-if="video_id==1" src="../../assets/img/auAnalysis/hotWord1.png" alt="">
      <img v-else src="../../assets/img/auAnalysis/hotWord2.png" alt="">
      <div class="title_box">相关评论</div>
      <div class="list_item" v-for="item in video_id==1?viewData.data1:viewData.data2" :key="item.name">
        <div class="img_box"><img :src="item.url" alt=""></div>
        <div class="viewer_box">
          <div class="name_box"><span><span>{{ item.name }}</span><span>{{ item.time }}</span></span><span><img style="width: 12px;margin-right: 3px;" src="../../assets/img/audienceAvator/loveIcon.png" alt="">{{ item.loveValue }}</span>
          </div>
          <div class="content"><span v-html="item.content"></span></div>
        </div>
      </div>
    </div>
    <div class="view_more">
      探索更多创作灵感<i class="el-icon-arrow-right"></i>
    </div>
  </div>
</template>
      
  <script>
export default {
  data() {
    return {
      video_id: this.$route.query.video_id,
      viewData: {
        data1: [
          {
            id: 1,
            url: require("../../assets/img/audienceAvator/viewAv2.png"),
            name: "王卉",
            time: "2025-02-15",
            content: `<span>这段话在韦雪直播那听了一遍，一个字不差<span style="color: #da637c;">喜欢吃</span>莲雾吗。。。。。</span>`,
            loveValue: 4,
          },
          {
            id: 1,
            url: require("../../assets/img/audienceAvator/viewAv3.png"),
            name: "胡忱钰钦",
            time: "2025-02-14",
            content: `<span>我也特别<span style="color: #da637c;">喜欢吃</span>这个!如果是青椒响还会蘸番茄酱，超级好吃</span>`,
            loveValue: 0,
          },
          {
            id: 1,
            url: require("../../assets/img/audienceAvator/viewAv4.png"),
            name: "化妆师小雪",
            time: "2025-02-14",
            content: `<span>我也超级<span style="color: #da637c;">喜欢吃</span></span>`,
            loveValue: 0,
          },
        ],
        data2: [
          {
            id: 1,
            url: require("../../assets/img/audienceAvator/viewAv1.png"),
            name: "江天尊",
            time: "2025-02-19",
            content: `<span>@<span style="color: #da637c;">血刀老祖</span>涛哥 @蜡笔小鑫.我这个怎么样</span>`,
            loveValue: 1,
          },
        ],
      },
    };
  },
  mounted() {},

  methods: {},
};
</script>
      
      <style scoped lang="scss">
.show_data_box {
  padding: 10px 10px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 4px;
  .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 5px;
    .title {
      font-size: 16px;
      font-weight: 600;
    }
    .tip {
      font-size: 12px;
      color: #b3b3b7;
    }
  }
  img {
    width: 100%;
  }
  .title_box {
    color: #73747a;
    font-size: 15px;
    font-weight: 600;
  }
  .list_item {
    padding: 10px 0;
    display: flex;
    align-items: center;
    .img_box {
      width: 48px;
      height: 48px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .viewer_box {
      flex: 1;
      margin-left: 10px;
      .name_box {
        display: flex;
        justify-content: space-between;
        color: #9c9ca1;
        font-size: 13px;
      }
      .content {
        margin-top: 5px;
        font-size: 14px;
      }
    }
  }
}
.view_more {
  margin: 20px 0;
  width: 100%;
  background: #fff;
  border-radius: 4px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 15px;
  .el-icon-arrow-right {
    color: #333;
    font-weight: 600;
    font-size: 18px;
    margin-top: 2px;
  }
}
</style>
      